import React from 'react';
import './DownloadCTA.css';

const DownloadCTA: React.FC = () => {
  return (
    <section id="download" className="download-cta">
      <div className="download-cta__bg">
        <div className="download-cta__shape download-cta__shape--1" />
        <div className="download-cta__shape download-cta__shape--2" />
      </div>
      <div className="container">
        <div className="download-cta__content">
          <h2 className="download-cta__title">
            Ready to Take Control of Your Health?
          </h2>
          <p className="download-cta__subtitle">
            Download Wary today and start your journey to better health. Available on
            Android and iOS.
          </p>
          <div className="download-cta__buttons">
            <a href="#" className="download-cta__store-btn" aria-label="Download on Google Play">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.199l2.302 2.302a1 1 0 0 1 0 1.38l-2.302 2.302L15.396 12l2.302-3.492zM5.864 2.658L16.8 9.49l-2.302 2.302L5.864 2.658z" />
              </svg>
              <div>
                <span className="download-cta__store-label">GET IT ON</span>
                <span className="download-cta__store-name">Google Play</span>
              </div>
            </a>
            <a href="#" className="download-cta__store-btn" aria-label="Download on App Store">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 21.99 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.1 21.99C7.79 22.03 6.8 20.68 5.96 19.47C4.25 16.97 2.94 12.45 4.7 9.39C5.57 7.87 7.13 6.91 8.82 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" />
              </svg>
              <div>
                <span className="download-cta__store-label">Download on the</span>
                <span className="download-cta__store-name">App Store</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadCTA;
